var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 91",
    width: 90,
    height: 91,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete-icon-circle-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none } \n\t\t.s1 { fill: none;stroke: #707070;stroke-width: .5 } \n\t\t.s2 { fill: #111111 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10541"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3629-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m45.5 1c24.6 0 44.5 19.9 44.5 44.5 0 24.6-19.9 44.5-44.5 44.5-24.6 0-44.5-19.9-44.5-44.5 0-24.6 19.9-44.5 44.5-44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m45.5 1.3v-0.1c24.4 0 44.3 19.9 44.3 44.3 0 24.4-19.9 44.3-44.3 44.3-24.4 0-44.3-19.9-44.3-44.3 0-24.4 19.9-44.3 44.3-44.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght300_GRAD0_opsz24",
    fillRule: "evenodd",
    className: "s2",
    d: "m33.2 67.4q-0.4 0-0.9-0.1-0.4 0-0.9-0.2-0.4-0.2-0.8-0.4-0.3-0.3-0.7-0.6-0.3-0.4-0.6-0.7-0.2-0.4-0.4-0.8-0.2-0.5-0.2-0.9-0.1-0.5-0.1-0.9v-32.7h-2.6v-3.8h11.6v-2.3h15.4v2.3h11.6v3.8h-2.6v32.7q0 0.4-0.1 0.9-0.1 0.4-0.2 0.9-0.2 0.4-0.5 0.8-0.2 0.4-0.5 0.7-0.4 0.3-0.7 0.6-0.4 0.2-0.9 0.4-0.4 0.2-0.8 0.3-0.5 0-0.9 0zm24.9-37.3h-25.7v32.7q0 0.1 0 0.1 0 0.1 0 0.2 0 0.1 0.1 0.1 0 0.1 0.1 0.1 0 0.1 0.1 0.1 0.1 0.1 0.2 0.1 0 0 0.1 0.1 0.1 0 0.2 0h24.1q0.1 0 0.1 0 0.1-0.1 0.2-0.1 0.1 0 0.1-0.1 0.1 0 0.1-0.1 0.1 0 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.2 0 0 0-0.1zm-19.5 5.1h3.8v23.2h-3.8zm9.4 0h3.9v23.1h-3.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconCircle);
export default __webpack_public_path__ + "static/media/delete-icon-circle.955842274012457f19acf89e556f1339.svg";
export { ForwardRef as ReactComponent };